export const NR2J_PIPELINE_STAGES = [
  { id: 'NOUVEAU', label: 'Nouveau' },
  { id: 'A_CONTACTER', label: 'À contacter' },
  { id: 'CONTACTE', label: 'Contacté' },
  { id: 'QUALIFIE', label: 'Qualifié' },
  { id: 'RDV', label: 'RDV' },
  { id: 'PROPOSITION', label: 'Proposition' },
  { id: 'NEGOCIATION', label: 'Négociation' },
  { id: 'GAGNE', label: 'Gagné' },
  { id: 'PERDU', label: 'Perdu' },
];

/** Pipeline commercial actif (dashboard) — hors états terminaux GAGNE / PERDU. */
export const NR2J_ACTIVE_PIPELINE_STAGES = [
  'NOUVEAU',
  'A_CONTACTER',
  'CONTACTE',
  'QUALIFIE',
  'RDV',
  'PROPOSITION',
  'NEGOCIATION',
];

export const NR2J_TASK_TYPES = [
  { id: 'APPEL', label: 'Appel' },
  { id: 'EMAIL', label: 'Email' },
  { id: 'RDV', label: 'RDV' },
  { id: 'RELANCE', label: 'Relance' },
  { id: 'SUIVI', label: 'Suivi' },
  { id: 'AUTRE', label: 'Autre' },
];

export const NR2J_TASK_STATUSES = [
  { id: 'OPEN', label: 'À faire' },
  { id: 'DONE', label: 'Terminée' },
  { id: 'CANCELLED', label: 'Annulée' },
];

export const NR2J_COMMERCIAL_STATUS = [
  { id: 'PROSPECT', label: 'Prospect' },
  { id: 'CLIENT', label: 'Client NR2J' },
  { id: 'INACTIVE', label: 'Archivée' },
];

export function nr2jStageLabel(stage) {
  return NR2J_PIPELINE_STAGES.find((s) => s.id === stage)?.label || stage || '—';
}

export function nr2jTaskStatusLabel(status) {
  return NR2J_TASK_STATUSES.find((s) => s.id === status)?.label || status || '—';
}

export function nr2jTaskTypeLabel(type) {
  return NR2J_TASK_TYPES.find((t) => t.id === type)?.label || type || '—';
}

export function nr2jStatusBadge(status) {
  if (status === 'CLIENT') {
    return { label: 'Client NR2J', className: 'bg-emerald-50 text-emerald-800 border-emerald-200' };
  }
  if (status === 'INACTIVE') {
    return { label: 'Archivée', className: 'bg-gray-100 text-gray-700 border-gray-200' };
  }
  return { label: 'Prospect', className: 'bg-amber-50 text-amber-900 border-amber-200' };
}

export function formatNr2jDate(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('fr-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}

export function organizationDisplayName(org) {
  if (!org) return 'Société';
  return org.nomCommercial || org.raisonSociale || org.ville || 'Société sans nom';
}

/**
 * Affichage contact NR2J : Prénom Nom (fallback email).
 */
export function contactDisplayName(contact) {
  if (!contact) return '';
  const name = [contact.prenom, contact.nom].filter(Boolean).join(' ').trim();
  if (name) return name;
  return contact.email || '';
}

// —— LOT2 : catalogue & devis ——

export const NR2J_CATALOG_BILLING_TYPES = [
  { id: 'ONE_TIME', label: 'Ponctuel' },
  { id: 'RECURRING_MONTHLY', label: 'Mensuel' },
  { id: 'RECURRING_YEARLY', label: 'Annuel' },
];

export const NR2J_VAT_OPTIONS = [
  { bps: 2000, label: '20 %' },
  { bps: 1000, label: '10 %' },
  { bps: 550, label: '5,5 %' },
  { bps: 0, label: '0 %' },
];

export const NR2J_QUOTE_STATUS_FILTERS = [
  { id: '', label: 'Tous' },
  { id: 'DRAFT', label: 'Brouillons' },
  { id: 'SENT', label: 'Envoyés' },
  { id: 'ACCEPTED', label: 'Acceptés' },
  { id: 'REFUSED', label: 'Refusés' },
  { id: 'EXPIRED', label: 'Expirés' },
  { id: 'CANCELLED', label: 'Annulés' },
];

const QUOTE_STATUS_LABELS = {
  DRAFT: 'Brouillon',
  SENT: 'Envoyé',
  ACCEPTED: 'Accepté',
  REFUSED: 'Refusé',
  CANCELLED: 'Annulé',
  EXPIRED: 'Expiré',
};

export function nr2jBillingTypeLabel(type) {
  return NR2J_CATALOG_BILLING_TYPES.find((t) => t.id === type)?.label || type || '—';
}

/** Portée informative de la remise — déduite de la fréquence de facturation (MVP). */
export function nr2jDiscountScopeLabel(billingType) {
  if (billingType === 'RECURRING_MONTHLY') return 'Appliquée à chaque mensualité';
  if (billingType === 'RECURRING_YEARLY') return 'Appliquée à chaque échéance annuelle';
  return 'Appliquée une seule fois';
}

export function nr2jBillingPeriodSuffix(billingType) {
  if (billingType === 'RECURRING_MONTHLY') return ' / mois';
  if (billingType === 'RECURRING_YEARLY') return ' / an';
  return '';
}

export function nr2jQuoteStatusLabel(status) {
  return QUOTE_STATUS_LABELS[status] || status || '—';
}

export function nr2jVatLabel(bps) {
  return NR2J_VAT_OPTIONS.find((v) => v.bps === bps)?.label || `${bps / 100} %`;
}

/** euros (max 2 décimales) → centimes entiers */
export function eurosToCents(euros) {
  if (euros === null || euros === undefined || euros === '') return 0;
  const n = Number(String(euros).replace(',', '.'));
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}

/** centimes → nombre euros pour affichage */
export function centsToEuros(cents) {
  if (cents === null || cents === undefined || cents === '') return '';
  const n = Number(cents);
  if (!Number.isFinite(n)) return '';
  return (n / 100).toFixed(2);
}

export function formatCentsAsEuros(cents) {
  const n = Number(cents);
  if (!Number.isFinite(n)) return '—';
  return (n / 100).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Statut effectif : SENT + validUntil < now → EXPIRED (sans muter la DB).
 */
export function effectiveStatus(version, now = new Date()) {
  if (!version) return null;
  const status = version.status;
  if (status === 'SENT' && version.validUntil) {
    const until = version.validUntil instanceof Date
      ? version.validUntil
      : new Date(version.validUntil);
    if (Number.isFinite(until.getTime()) && until.getTime() < now.getTime()) {
      return 'EXPIRED';
    }
  }
  return status;
}

export function nr2jQuoteStatusBadge(status) {
  switch (status) {
    case 'DRAFT':
      return { label: 'Brouillon', className: 'bg-gray-100 text-gray-800 border-gray-200' };
    case 'SENT':
      return { label: 'Envoyé', className: 'bg-blue-50 text-blue-800 border-blue-200' };
    case 'ACCEPTED':
      return { label: 'Accepté', className: 'bg-emerald-50 text-emerald-800 border-emerald-200' };
    case 'REFUSED':
      return { label: 'Refusé', className: 'bg-rose-50 text-rose-800 border-rose-200' };
    case 'CANCELLED':
      return { label: 'Annulé', className: 'bg-gray-100 text-gray-600 border-gray-200' };
    case 'EXPIRED':
      return { label: 'Expiré', className: 'bg-amber-50 text-amber-900 border-amber-200' };
    default:
      return { label: nr2jQuoteStatusLabel(status), className: 'bg-gray-100 text-gray-700 border-gray-200' };
  }
}

/** Badge liste devis : un brouillon soumis à validation affiche l'état de la demande. */
export function nr2jQuoteListBadge(status, approvalStatus = null) {
  if (status === 'DRAFT') {
    switch (approvalStatus) {
      case 'PENDING':
        return { label: 'En attente de validation', className: 'bg-amber-50 text-amber-900 border-amber-200' };
      case 'APPROVED':
        return { label: 'Validé — prêt à envoyer', className: 'bg-emerald-50 text-emerald-800 border-emerald-200' };
      case 'CHANGES_REQUESTED':
        return { label: 'Modifications demandées', className: 'bg-orange-50 text-orange-900 border-orange-200' };
      case 'REJECTED':
        return { label: 'Refusé en interne', className: 'bg-rose-50 text-rose-800 border-rose-200' };
      default:
        break;
    }
  }
  return nr2jQuoteStatusBadge(status);
}

function roundHalfUp(value) {
  return Math.sign(value) * Math.round(Math.abs(value));
}

/** Calcul ligne devis côté client (miroir backend simplifié). */
export function computeQuoteLineTotals(line) {
  const qty = Math.max(1, Number(line.quantity) || 1);
  const unit = Math.max(0, Number(line.unitPriceHtCents) || 0);
  const vatBps = Number(line.vatRateBps) ?? 2000;
  const grossHtCents = unit * qty;

  let discountHtCents = 0;
  const hasPct = line.discountPercentBps != null && line.discountPercentBps !== '';
  const hasFixed = line.discountAmountHtCents != null && line.discountAmountHtCents !== '';
  if (hasPct && !hasFixed) {
    discountHtCents = roundHalfUp((grossHtCents * Number(line.discountPercentBps)) / 10000);
  } else if (hasFixed) {
    discountHtCents = Math.min(grossHtCents, Math.max(0, Number(line.discountAmountHtCents) || 0));
  }

  const lineHtCents = Math.max(0, grossHtCents - discountHtCents);
  const lineVatCents = roundHalfUp((lineHtCents * vatBps) / 10000);
  const lineTtcCents = lineHtCents + lineVatCents;

  return { lineHtCents, lineVatCents, lineTtcCents, grossHtCents, discountHtCents };
}

export function sumQuoteTotals(lines) {
  let totalGrossHtCents = 0;
  let totalDiscountHtCents = 0;
  let totalHtCents = 0;
  let totalVatCents = 0;
  let totalTtcCents = 0;
  for (const line of lines) {
    const t = computeQuoteLineTotals(line);
    totalGrossHtCents += t.grossHtCents;
    totalDiscountHtCents += t.discountHtCents;
    totalHtCents += t.lineHtCents;
    totalVatCents += t.lineVatCents;
    totalTtcCents += t.lineTtcCents;
  }
  return {
    totalGrossHtCents,
    totalDiscountHtCents,
    totalHtCents,
    totalVatCents,
    totalTtcCents,
  };
}

const BILLING_SUMMARY_ORDER = ['ONE_TIME', 'RECURRING_MONTHLY', 'RECURRING_YEARLY'];

function billingPeriodSuffix(type) {
  if (type === 'RECURRING_MONTHLY') return ' / mois';
  if (type === 'RECURRING_YEARLY') return ' / an';
  return '';
}

/**
 * Totaux séparés par fréquence de facturation (présentation vendeur / PDF).
 * Ne pas additionner ponctuel + mensuel + annuel en un seul TTC.
 */
export function sumQuoteTotalsByBillingType(lines) {
  const map = new Map();
  for (const line of lines || []) {
    const key = line.billingType || 'ONE_TIME';
    const computed = computeQuoteLineTotals(line);
    const cur = map.get(key) || {
      billingType: key,
      totalGrossHtCents: 0,
      totalDiscountHtCents: 0,
      totalHtCents: 0,
      totalVatCents: 0,
      totalTtcCents: 0,
    };
    cur.totalGrossHtCents += computed.grossHtCents;
    cur.totalDiscountHtCents += computed.discountHtCents;
    cur.totalHtCents += computed.lineHtCents;
    cur.totalVatCents += computed.lineVatCents;
    cur.totalTtcCents += computed.lineTtcCents;
    map.set(key, cur);
  }
  return BILLING_SUMMARY_ORDER
    .filter((k) => map.has(k))
    .map((k) => {
      const row = map.get(k);
      return {
        ...row,
        label: nr2jBillingTypeLabel(k),
        periodSuffix: billingPeriodSuffix(k),
      };
    });
}

/**
 * Due à la souscription pour devis mixtes (présentation vendeur).
 * show=false si un seul billingType.
 */
export function sumQuoteDueAtSubscription(lines) {
  const billingTotals = sumQuoteTotalsByBillingType(lines);
  if (billingTotals.length <= 1) {
    return { show: false, parts: [], totalTtcCents: 0, recurringAfter: [] };
  }
  const byType = Object.fromEntries(billingTotals.map((b) => [b.billingType, b]));
  const parts = [];
  let totalTtcCents = 0;
  if (byType.ONE_TIME) {
    parts.push({
      billingType: 'ONE_TIME',
      label: 'Frais ponctuels',
      totalTtcCents: byType.ONE_TIME.totalTtcCents,
    });
    totalTtcCents += byType.ONE_TIME.totalTtcCents;
  }
  if (byType.RECURRING_MONTHLY) {
    parts.push({
      billingType: 'RECURRING_MONTHLY',
      label: 'Première mensualité',
      totalTtcCents: byType.RECURRING_MONTHLY.totalTtcCents,
    });
    totalTtcCents += byType.RECURRING_MONTHLY.totalTtcCents;
  }
  if (byType.RECURRING_YEARLY) {
    parts.push({
      billingType: 'RECURRING_YEARLY',
      label: 'Première échéance annuelle',
      totalTtcCents: byType.RECURRING_YEARLY.totalTtcCents,
    });
    totalTtcCents += byType.RECURRING_YEARLY.totalTtcCents;
  }
  const recurringAfter = [];
  if (byType.RECURRING_MONTHLY) {
    recurringAfter.push({
      billingType: 'RECURRING_MONTHLY',
      label: 'Puis',
      totalTtcCents: byType.RECURRING_MONTHLY.totalTtcCents,
      periodSuffix: ' / mois',
    });
  }
  if (byType.RECURRING_YEARLY) {
    recurringAfter.push({
      billingType: 'RECURRING_YEARLY',
      label: 'Puis',
      totalTtcCents: byType.RECURRING_YEARLY.totalTtcCents,
      periodSuffix: ' / an',
    });
  }
  return { show: true, parts, totalTtcCents, recurringAfter };
}

export const NR2J_QUOTE_SEND_GATE_LABELS = {
  'raisonSociale|nomCommercial': 'Identité société (raison sociale ou nom commercial)',
  adresse: 'Adresse',
  codePostal: 'Code postal',
  ville: 'Ville',
  pays: 'Pays',
  recipientEmail: 'Email destinataire',
  validUntil: 'Validité jusqu’au',
};

/** Champs gate liés à l’éditeur devis (vs fiche société). */
export const NR2J_QUOTE_EDITOR_GATE_KEYS = new Set(['validUntil', 'recipientEmail']);

export const NR2J_QUOTE_ORG_GATE_KEYS = new Set([
  'raisonSociale|nomCommercial',
  'adresse',
  'codePostal',
  'ville',
  'pays',
  'recipientEmail',
]);

/** Map gate key → champs formulaire fiche société à surligner. */
export const NR2J_QUOTE_GATE_TO_ORG_FIELDS = Object.freeze({
  'raisonSociale|nomCommercial': ['raisonSociale', 'nomCommercial'],
  adresse: ['adresse'],
  codePostal: ['codePostal'],
  ville: ['ville'],
  pays: ['pays'],
  recipientEmail: ['emailPrincipal', 'emailFacturation'],
});

/** Map clés collectConversionMissing → champs formulaire / section. */
export const NR2J_CONVERSION_TO_ORG_FIELDS = Object.freeze({
  identity: ['raisonSociale', 'nomCommercial'],
  siren: ['siren'],
  'siren|siret|tvaIntracommunautaire': ['siren', 'siret', 'tvaIntracommunautaire'],
  siret: ['siret'],
  email: ['emailPrincipal', 'emailFacturation'],
  adresse: ['adresse'],
  codePostal: ['codePostal'],
  ville: ['ville'],
  pays: ['pays'],
  primaryContact: ['primaryContact'],
});

export const NR2J_CONVERSION_MISSING_LABELS = Object.freeze({
  identity: 'Identité (raison sociale ou nom commercial)',
  siren: 'SIREN',
  siret: 'SIRET',
  email: 'Email principal ou facturation',
  adresse: 'Adresse',
  codePostal: 'Code postal',
  ville: 'Ville',
  pays: 'Pays',
  primaryContact: 'Contact principal (prénom, nom, email)',
});

export function mapConversionMissingToOrgFields(missingKeys = []) {
  const keys = [];
  for (const gateKey of missingKeys || []) {
    const mapped = NR2J_CONVERSION_TO_ORG_FIELDS[gateKey] || NR2J_QUOTE_GATE_TO_ORG_FIELDS[gateKey] || [];
    keys.push(...mapped);
  }
  return [...new Set(keys)];
}

/**
 * URL fiche société pour compléter conversion / facture.
 * missingKeys = clés métier (siren, siret, primaryContact, …) ou gates devis.
 */
export function buildOrgFicheUrlFromConversion({
  organizationId,
  quoteId,
  missingKeys = [],
  intent = 'convert',
} = {}) {
  if (!organizationId) return null;
  const params = new URLSearchParams();
  const list = (missingKeys || []).filter(Boolean);
  if (list.length) params.set('missing', list.join(','));
  if (intent) params.set('intent', intent);
  if (quoteId) params.set('returnTo', `/nr2j/devis/${quoteId}`);
  const qs = params.toString();
  return `/nr2j/clients/${organizationId}${qs ? `?${qs}` : ''}`;
}

export function buildOrgFicheUrlFromQuoteGate({ organizationId, quoteId, missingKeys = [] }) {
  if (!organizationId) return null;
  const params = new URLSearchParams();
  const orgKeys = (missingKeys || []).filter((k) => NR2J_QUOTE_ORG_GATE_KEYS.has(k));
  if (orgKeys.length) params.set('missing', orgKeys.join(','));
  params.set('intent', 'quote');
  if (quoteId) params.set('returnTo', `/nr2j/devis/${quoteId}`);
  const qs = params.toString();
  return `/nr2j/clients/${organizationId}${qs ? `?${qs}` : ''}`;
}

/** Recalcule les manques org côté client (aligné backend collectBuyerGateMissing). */
export function computeOrgSendGateMissing(org, contacts = []) {
  const missing = [];
  if (!org) return ['raisonSociale|nomCommercial', 'adresse', 'codePostal', 'ville', 'pays', 'recipientEmail'];
  if (!org.raisonSociale && !org.nomCommercial) missing.push('raisonSociale|nomCommercial');
  if (!org.adresse || !String(org.adresse).trim()) missing.push('adresse');
  if (!org.codePostal || !String(org.codePostal).trim()) missing.push('codePostal');
  if (!org.ville || !String(org.ville).trim()) missing.push('ville');
  if (!org.pays || !String(org.pays).trim()) missing.push('pays');
  const contactEmail = (contacts || []).map((c) => c?.email).find((e) => e && /@/.test(String(e)));
  const recipient = contactEmail || org.emailFacturation || org.emailPrincipal || null;
  if (!recipient || !/@/.test(String(recipient))) missing.push('recipientEmail');
  return missing;
}

/**
 * Aligné backend collectConversionMissing (sans inventer SIREN/SIRET).
 * @param {{ forInvoice?: boolean }} [opts]
 *   forInvoice=true : contact principal non requis si email société valide
 *   (aligné collectInvoiceConversionMissing).
 */
export function computeConversionMissing(org, contacts = [], opts = {}) {
  const forInvoice = Boolean(opts.forInvoice);
  const missing = [];
  if (!org) {
    return forInvoice
      ? ['identity', 'siren', 'siret', 'email', 'adresse', 'codePostal', 'ville']
      : ['identity', 'siren', 'siret', 'email', 'adresse', 'codePostal', 'ville', 'primaryContact'];
  }
  const trim = (v) => (v == null ? '' : String(v).trim());
  if (!trim(org.raisonSociale) && !trim(org.nomCommercial)) missing.push('identity');
  const sirenDigits = trim(org.siren).replace(/\D/g, '');
  if (sirenDigits.length !== 9) missing.push('siren');
  const siretDigits = trim(org.siret).replace(/\D/g, '');
  if (siretDigits.length !== 14) missing.push('siret');
  else if (sirenDigits.length === 9 && siretDigits.slice(0, 9) !== sirenDigits) missing.push('siret');
  const billingEmail = trim(org.emailFacturation);
  const principalEmail = trim(org.emailPrincipal);
  const email = billingEmail || principalEmail;
  if (!email || !/@/.test(email)) missing.push('email');
  if (!trim(org.adresse)) missing.push('adresse');
  if (!trim(org.codePostal)) missing.push('codePostal');
  if (!trim(org.ville)) missing.push('ville');
  const hasOrgEmail = Boolean(email && /@/.test(email));
  const requirePrimaryContact = forInvoice ? !hasOrgEmail : true;
  if (requirePrimaryContact) {
    const primary = (contacts || []).find((c) => c.isPrimary === true);
    if (
      !primary
      || !trim(primary.prenom)
      || !trim(primary.nom)
      || !trim(primary.email)
      || !/@/.test(String(primary.email))
    ) {
      missing.push('primaryContact');
    }
  }
  return missing;
}

/**
 * Bandeau fiche devis : gate envoi + gate facture (conversion) pour devis ACCEPTED sans facture liée.
 */
export function computeQuoteOrgBannerMissingKeys({
  persistentMissing = [],
  org,
  contacts = [],
  isAccepted = false,
  hasLinkedInvoice = false,
} = {}) {
  const send = (persistentMissing || []).filter((k) => NR2J_QUOTE_ORG_GATE_KEYS.has(k));
  if (!isAccepted || hasLinkedInvoice) return send;
  const invoiceMissing = computeConversionMissing(org, contacts, { forInvoice: true });
  const convOrgKeys = invoiceMissing.filter((k) => k !== 'primaryContact');
  return [...new Set([...send, ...convOrgKeys])];
}

/** Validité immédiate d’un champ fiche (rouge → vert sans save). */
export function isNr2jOrgFieldSatisfied(fieldKey, value, draftOrg = {}) {
  const trim = (v) => (v == null ? '' : String(v).trim());
  const v = trim(value);
  if (fieldKey === 'raisonSociale' || fieldKey === 'nomCommercial') {
    return Boolean(trim(draftOrg.raisonSociale) || trim(draftOrg.nomCommercial) || v);
  }
  if (fieldKey === 'siren') return v.replace(/\D/g, '').length === 9;
  if (fieldKey === 'siret') return v.replace(/\D/g, '').length === 14;
  if (fieldKey === 'emailPrincipal' || fieldKey === 'emailFacturation') {
    const email = trim(draftOrg.emailFacturation) || trim(draftOrg.emailPrincipal) || v;
    return Boolean(email && /@/.test(email));
  }
  if (fieldKey === 'adresse' || fieldKey === 'codePostal' || fieldKey === 'ville' || fieldKey === 'pays') {
    return Boolean(v);
  }
  return Boolean(v);
}

/** Date ISO yyyy-mm-dd à J+30 (local). */
export function defaultValidUntilInput(from = new Date()) {
  const d = new Date(from);
  d.setDate(d.getDate() + 30);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function quoteVersionCountLabel(quote) {
  const count = quote?.versionCount ?? quote?.versions?.length ?? 0;
  const v = quote?.currentVersion?.version;
  if (!v) return '—';
  if (count > 1) return `v${v} · ${count} versions`;
  return `Version actuelle : v${v}`;
}

export function isQuoteFullyDraftDeletable(quote) {
  if (quote?.deletable === true) return true;
  if (quote?.deletable === false) return false;
  const versions = quote?.versions || [];
  if (!versions.length) return true;
  return versions.every((v) => v.status === 'DRAFT' && !v.sentAt);
}

export function nr2jEmailLogStatusLabel(status) {
  const map = {
    SENT: 'Envoyé',
    FAILED: 'Échec',
    SKIPPED: 'Ignoré',
  };
  return map[status] || status || '';
}

// —— Facturation MVP : factures / avoirs / paiements ——

export const NR2J_INVOICE_STATUSES = [
  { id: 'DRAFT', label: 'Brouillon' },
  { id: 'ISSUED', label: 'Émise' },
  { id: 'SENT', label: 'Envoyée' },
];

export const NR2J_CREDIT_NOTE_STATUSES = [
  { id: 'DRAFT', label: 'Brouillon' },
  { id: 'ISSUED', label: 'Émis' },
];

export const NR2J_INVOICE_PAYMENT_METHODS = [
  { id: 'VIREMENT', label: 'Virement' },
  { id: 'PRELEVEMENT', label: 'Prélèvement' },
  { id: 'CARTE', label: 'Carte' },
  { id: 'CHEQUE', label: 'Chèque' },
  { id: 'ESPECES', label: 'Espèces' },
  { id: 'AUTRE', label: 'Autre' },
];

export const NR2J_INVOICE_LIST_FILTERS = [
  { id: '', label: 'Toutes' },
  { id: 'TO_PAY', label: 'À payer' },
  { id: 'OVERDUE', label: 'En retard' },
  { id: 'PARTIAL', label: 'Partiellement payées' },
  { id: 'PAID', label: 'Payées' },
  { id: 'DRAFT', label: 'Brouillons' },
  { id: 'CREDITED', label: 'Créditées' },
];

const INVOICE_STATUS_LABELS = {
  DRAFT: 'Brouillon',
  ISSUED: 'Émise',
  SENT: 'Envoyée',
};

const CREDIT_NOTE_STATUS_LABELS = {
  DRAFT: 'Brouillon',
  ISSUED: 'Émis',
};

const PAYMENT_STATE_LABELS = {
  UNPAID: 'Impayée',
  PARTIAL: 'Partiellement payée',
  PAID: 'Payée',
};

const CREDIT_STATE_LABELS = {
  NONE: 'Aucun avoir',
  PARTIAL: 'Avoir partiel',
  FULL: 'Avoir total',
};

export function nr2jInvoiceStatusLabel(status) {
  return INVOICE_STATUS_LABELS[status] || status || '—';
}

export function nr2jCreditNoteStatusLabel(status) {
  return CREDIT_NOTE_STATUS_LABELS[status] || status || '—';
}

export function nr2jPaymentStateLabel(state) {
  return PAYMENT_STATE_LABELS[state] || state || '—';
}

export function nr2jCreditStateLabel(state) {
  return CREDIT_STATE_LABELS[state] || state || '—';
}

export function nr2jPaymentMethodLabel(method) {
  return NR2J_INVOICE_PAYMENT_METHODS.find((m) => m.id === method)?.label || method || '—';
}

export function nr2jInvoiceStatusBadge(status) {
  switch (status) {
    case 'DRAFT':
      return { label: 'Brouillon', className: 'bg-gray-100 text-gray-800 border-gray-200' };
    case 'ISSUED':
      return { label: 'Émise', className: 'bg-blue-50 text-blue-800 border-blue-200' };
    case 'SENT':
      return { label: 'Envoyée', className: 'bg-indigo-50 text-indigo-800 border-indigo-200' };
    default:
      return {
        label: nr2jInvoiceStatusLabel(status),
        className: 'bg-gray-100 text-gray-700 border-gray-200',
      };
  }
}

export function nr2jCreditNoteStatusBadge(status) {
  switch (status) {
    case 'DRAFT':
      return { label: 'Brouillon', className: 'bg-gray-100 text-gray-800 border-gray-200' };
    case 'ISSUED':
      return { label: 'Émis', className: 'bg-emerald-50 text-emerald-800 border-emerald-200' };
    default:
      return {
        label: nr2jCreditNoteStatusLabel(status),
        className: 'bg-gray-100 text-gray-700 border-gray-200',
      };
  }
}

/**
 * Badge d’état métier liste / détail (statut + paiement + retard + crédit).
 */
export function nr2jInvoiceDisplayBadge(invoice) {
  if (!invoice) {
    return { label: '—', className: 'bg-gray-100 text-gray-700 border-gray-200' };
  }
  if (invoice.status === 'DRAFT') {
    return nr2jInvoiceStatusBadge('DRAFT');
  }
  if (invoice.overdue) {
    return { label: 'En retard', className: 'bg-rose-50 text-rose-800 border-rose-200' };
  }
  if (invoice.creditState === 'FULL') {
    return { label: 'Créditée', className: 'bg-violet-50 text-violet-800 border-violet-200' };
  }
  if (invoice.paymentState === 'PAID') {
    return { label: 'Payée', className: 'bg-emerald-50 text-emerald-800 border-emerald-200' };
  }
  if (invoice.paymentState === 'PARTIAL') {
    return {
      label: 'Partiellement payée',
      className: 'bg-amber-50 text-amber-900 border-amber-200',
    };
  }
  if (invoice.creditState === 'PARTIAL') {
    return { label: 'Avoir partiel', className: 'bg-violet-50 text-violet-700 border-violet-200' };
  }
  if (invoice.paymentState === 'UNPAID') {
    return { label: 'À payer', className: 'bg-orange-50 text-orange-900 border-orange-200' };
  }
  return nr2jInvoiceStatusBadge(invoice.status);
}

export function matchesInvoiceListFilter(invoice, filterId) {
  if (!filterId) return true;
  if (filterId === 'DRAFT') return invoice.status === 'DRAFT';
  if (filterId === 'OVERDUE') return invoice.overdue === true;
  if (filterId === 'PARTIAL') return invoice.paymentState === 'PARTIAL';
  if (filterId === 'PAID') {
    return invoice.paymentState === 'PAID' && invoice.status !== 'DRAFT';
  }
  if (filterId === 'TO_PAY') {
    return (
      (invoice.status === 'ISSUED' || invoice.status === 'SENT')
      && invoice.paymentState === 'UNPAID'
      && !invoice.overdue
    );
  }
  if (filterId === 'CREDITED') {
    return invoice.creditState === 'PARTIAL' || invoice.creditState === 'FULL';
  }
  return true;
}

/** Date ISO yyyy-mm-dd à J+30 (local) — échéance facture. */
export function defaultDueAtInput(from = new Date()) {
  return defaultValidUntilInput(from);
}

export function formatNr2jDateOnly(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return '—';
  }
}

export function toDateInputValue(value) {
  if (!value) return '';
  try {
    const d = value instanceof Date ? value : new Date(value);
    if (!Number.isFinite(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  } catch {
    return '';
  }
}

// —— Contrats NR2J ——

function isFrancePaysClient(pays) {
  const p = String(pays || '').trim().toUpperCase();
  return p === 'FR' || p === 'FRA' || p === 'FRANCE';
}

/** Aligné backend collectBuyerGateMissing (contrat envoi / émission). */
export function computeContractBuyerGateMissing(org) {
  const missing = [];
  if (!org) {
    return ['raisonSociale|nomCommercial', 'adresse', 'codePostal', 'ville', 'pays', 'siren'];
  }
  if (!org.raisonSociale && !org.nomCommercial) {
    missing.push('raisonSociale|nomCommercial');
  }
  if (!org.adresse || !String(org.adresse).trim()) missing.push('adresse');
  if (!org.codePostal || !String(org.codePostal).trim()) missing.push('codePostal');
  if (!org.ville || !String(org.ville).trim()) missing.push('ville');
  if (!org.pays || !String(org.pays).trim()) missing.push('pays');
  if (isFrancePaysClient(org.pays)) {
    if (!org.siren || !String(org.siren).trim()) missing.push('siren');
  } else {
    const hasId = Boolean(
      (org.siren && String(org.siren).trim())
      || (org.siret && String(org.siret).trim())
      || (org.tvaIntracommunautaire && String(org.tvaIntracommunautaire).trim()),
    );
    if (!hasId) missing.push('siren|siret|tvaIntracommunautaire');
  }
  return missing;
}

/** Gate acheteur facture (aligné backend invoice collectBuyerGateMissing). */
export function computeInvoiceBuyerGateMissing(org, contacts = [], contact = null) {
  const missing = computeOrgSendGateMissing(org, contacts);
  if (contact) {
    const email = contact.email || org?.emailFacturation || org?.emailPrincipal;
    if (email && /@/.test(String(email))) {
      return missing.filter((k) => k !== 'recipientEmail');
    }
  }
  return missing;
}

export function computeContractSendGateMissingClient(org, contact, contractVersion) {
  const missing = [
    ...computeContractBuyerGateMissing(org),
    ...computeContractSignatoryGateMissing(contact),
  ];
  if (!contractVersion?.templateVersionId) missing.push('templateVersionId');
  if (!contractVersion?.lines?.length) missing.push('lines');
  return [...new Set(missing)];
}

/** Aligné backend assertSignatoryReady (gates envoi / soumission uniquement). */
export const NR2J_CONTRACT_SIGNATORY_GATE_LABELS = Object.freeze({
  signatoryName: 'Nom du signataire',
  signatoryEmail: 'Email du signataire',
  signatoryFunction: 'Fonction du signataire',
});

export function computeContractSignatoryGateMissing(contact) {
  const missing = [];
  if (!contact) {
    return ['signatoryName', 'signatoryEmail', 'signatoryFunction'];
  }
  const name = contactDisplayName(contact);
  const hasName = Boolean(
    (contact.prenom && String(contact.prenom).trim())
    || (contact.nom && String(contact.nom).trim())
    || (name && name !== 'Contact'),
  );
  if (!hasName) missing.push('signatoryName');
  if (!contact.email || !/@/.test(String(contact.email).trim())) {
    missing.push('signatoryEmail');
  }
  if (!contact.fonction || !String(contact.fonction).trim()) {
    missing.push('signatoryFunction');
  }
  return missing;
}

export const NR2J_CONTRACT_STATUS_FILTERS = [
  { id: '', label: 'Tous' },
  { id: 'DRAFT', label: 'Brouillons' },
  { id: 'SENT', label: 'Envoyés' },
  { id: 'SIGNED', label: 'Signés' },
  { id: 'REFUSED', label: 'Refusés' },
  { id: 'EXPIRED', label: 'Expirés' },
  { id: 'CANCELLED', label: 'Annulés' },
];

export const NR2J_CONTRACT_RENEWAL_MODES = [
  { id: 'TACITE', label: 'Reconduction tacite' },
  { id: 'SANS_RECONDUCTION', label: 'Sans reconduction' },
];

const CONTRACT_STATUS_LABELS = {
  DRAFT: 'Brouillon',
  SENT: 'Envoyé',
  SIGNED: 'Signé',
  REFUSED: 'Refusé',
  CANCELLED: 'Annulé',
  EXPIRED: 'Expiré',
};

export function nr2jContractStatusLabel(status) {
  return CONTRACT_STATUS_LABELS[status] || status || '—';
}

export function nr2jContractRenewalModeLabel(mode) {
  return NR2J_CONTRACT_RENEWAL_MODES.find((m) => m.id === mode)?.label || mode || '—';
}

/** Statut exposé UI : SENT + expiresAt < now → EXPIRED (sans muter). */
export function effectiveContractStatus(version, now = new Date()) {
  if (!version) return null;
  if (version.effectiveStatus) return version.effectiveStatus;
  const status = version.status;
  if (status === 'SENT' && version.expiresAt) {
    const until = version.expiresAt instanceof Date
      ? version.expiresAt
      : new Date(version.expiresAt);
    if (Number.isFinite(until.getTime()) && until.getTime() < now.getTime()) {
      return 'EXPIRED';
    }
  }
  return status;
}

export function nr2jContractStatusBadge(status) {
  switch (status) {
    case 'DRAFT':
      return { label: 'Brouillon', className: 'bg-gray-100 text-gray-800 border-gray-200' };
    case 'SENT':
      return { label: 'Envoyé', className: 'bg-blue-50 text-blue-800 border-blue-200' };
    case 'SIGNED':
      return {
        label: 'Contrat signé',
        className: 'bg-emerald-100 text-emerald-900 border-emerald-300 font-semibold ring-1 ring-emerald-200/80',
      };
    case 'REFUSED':
      return { label: 'Refusé', className: 'bg-rose-50 text-rose-800 border-rose-200' };
    case 'CANCELLED':
      return { label: 'Annulé', className: 'bg-gray-100 text-gray-600 border-gray-200' };
    case 'EXPIRED':
      return { label: 'Expiré', className: 'bg-amber-50 text-amber-900 border-amber-200' };
    default:
      return {
        label: nr2jContractStatusLabel(status),
        className: 'bg-gray-100 text-gray-700 border-gray-200',
      };
  }
}

export function nr2jContractListBadge(status, approvalStatus = null) {
  if (status === 'DRAFT') {
    switch (approvalStatus) {
      case 'PENDING':
        return { label: 'En attente de validation', className: 'bg-amber-50 text-amber-900 border-amber-200' };
      case 'APPROVED':
        return { label: 'Validé — prêt à envoyer', className: 'bg-emerald-50 text-emerald-800 border-emerald-200' };
      case 'CHANGES_REQUESTED':
        return { label: 'Modifications demandées', className: 'bg-orange-50 text-orange-900 border-orange-200' };
      case 'REJECTED':
        return { label: 'Refusé en interne', className: 'bg-rose-50 text-rose-800 border-rose-200' };
      default:
        break;
    }
  }
  return nr2jContractStatusBadge(status);
}
